/**
 * A tool's note (data/tool-notes.js) as HTML: the text, the glossary terms the
 * tool uses (each opens its card underneath, utils/term-cards.js), About this
 * tool (data/tool-about.js) folded under the text where the tool has one, its
 * sources, and links to Sources & method and to report an error. One renderer
 * for the header in the app (navigation.js) and each tool's static page
 * (scripts/seo-pages.mjs); the caller passes the terms (utils/glossary.js
 * termsOfTool) and the about text, so this module stays free of their data.
 */

import { escapeHtml } from './html.js';
import { errorReportHref } from './contact.js';

/** About this tool, folded: a summary to open it, then its sections. */
function aboutHtml(about) {
  const sections = about.sections
    .map((s) => `<h2 class="tool-about__h">${escapeHtml(s.title)}</h2>${s.paras.map((p) => `<p>${escapeHtml(p)}</p>`).join('')}`)
    .join('');
  return `<details class="tool-about"><summary>About this tool</summary><div class="tool-about__body">${sections}</div></details>`;
}

export function toolNoteHtml(note, tool, terms = [], about = null) {
  const sources = note.sources
    .map((s) => {
      const text = escapeHtml(s.text);
      return `<li>${s.url ? `<a href="${escapeHtml(s.url)}" target="_blank" rel="noopener noreferrer">${text}</a>` : text}</li>`;
    })
    .join('');
  const termsHtml = terms.length
    ? `<p class="tool-head__terms"><span class="tool-head__terms-label">Terms</span>${terms
        .map((t) => `<button type="button" class="term" data-term="${escapeHtml(t.id)}" aria-expanded="false" aria-controls="tool-head-term">${escapeHtml(t.term)}</button>`)
        .join('')}</p><div class="term-card" id="tool-head-term" hidden></div>`
    : '';
  return (
    `<p>${escapeHtml(note.text)}</p>${termsHtml}${about ? aboutHtml(about) : ''}<ul class="tool-head__sources">${sources}</ul>` +
    '<p class="tool-head__links"><a href="/sources" data-page="sources">Sources &amp; method</a>' +
    `<a href="${escapeHtml(errorReportHref(tool))}">Report an error</a></p>`
  );
}
